let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("imQWZ")).then(() => parcelRequire('9Yoaw'));